<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";
Vue.component("v-select", vSelect);
/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader,DatePicker},
  data() {
    return {
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {"x-token": this.$store.state.authfack.user.token},
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        totalArticulos: 0,
        total: "",
        state: true,
        id: 0,
        totalPendiente:0,
        totalPagado:0
      },
      fecha_inicial: "",
      rangode_fecha:"",
      search:'',
      arrayPro:[],
      fecha_final:"",
      reporteya:false,
      no_venta:0,
      estadoCredito:null,
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
    };
  },
  mounted() {
  },
  updated() {
    //this.$refs["buttonImprimir"].click();
  },
  methods: {
    resetV(){
        this.reporteya=false;
        this.rangode_fecha="";
        this.arrayPro=[];
        this.search='';
    },
    generar(){
    this.reporteya=true;
    this.detalle();
    },
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    onFiltered(escrito) {
     let idstockm = escrito.toLowerCase();
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/nuevo_get?departamento=0&estante=0&criterio=producto&order=desc&page=1&limite=200&search=" +
            idstockm,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          
          this.arrayPro=response.data.data;
          // console.log(this.historialpre)
          /*  this.formget.nombre=response.data.cabecera.nombre_auto;
       this.formget.state=response.data.cabecera.estado_auto; */
        });
    },
    async changeTypeDates(){
      await this.separarfechas()
    },
    separarfechas(){
      this.fecha_inicial=this.rangode_fecha[0]
      this.fecha_final=this.rangode_fecha[1]
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    detalle() {
      let me = this;
      let idstockf=me.search?me.search.stockId:'';
      axios
          .get(
              process.env.VUE_APP_URL +
              "reportes/reporteMovCompra?fecha_inicial="+ this.customFormatter(me.fecha_inicial) +"&fecha_final="+this.customFormatter(me.fecha_final)
              +"&idstock=" +idstockf,
              {
                headers: {"x-token": me.userT.token},
              }
          )
          .then((response) => {
            let detalleProducto = response.data.rows;
            me.detalleorden=detalleProducto
            me.formPro.totalArticulos =  response.data.count;
          });
    },
  },
};
</script>
<style>

</style>
<template>
  <Layout v-if="reporteya==true">
    <PageHeader :title="title" :items="items" class="d-print-none"/>
    <div class="row mt-4">
      <div class="col d-print-none">
        <b-button
                @click="resetV"
                class="ms-1"
                ><i  class="mdi mdi-arrow-left me-1"></i>REGRESAR</b-button
              >
      </div>
      <div class="col d-print-none">
        <div class="float-end">
          <a
              ref="buttonImprimir"
              href="javascript:window.print()"
              class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a
          >
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <div class="card-body">
            <div class="row">
                <div class="col-3"></div>
                <div class="col-6">
              <img
                  class="img-fluid float-right grises"
                  src="../../../../../src/assets/images/logoZonaR.png"
                  alt="Logo"
              />
              </div>
            </div>
            <br/>
            <div class="row" align="center">
              <div class="col" align="center">
                <h2 style="font-weight: bold;">Reporte compras</h2>
              </div>
            </div>
            <div class="row" align="center">
              <div class="col" align="left">
                <h5>Cantidad de productos:</h5>
              </div>
              <div class="col" align="left">
                <h5>{{ formPro.totalArticulos }}</h5> 
              </div>
              <div class="col" align="left">
               <h5>{{ showHour(new Date()) }} </h5>
              </div>
            </div>
            <div>
              <table class="table table-sm table-bordered table-striped">
               
                <tr style=" padding: 0 !important; margin: 0 !important;">
                    <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">No. Factura</h5></th>
                    <th style=" padding: 0 !important; margin: 0 !important;">
                    <h5 style="font-weight: bold;">Fecha</h5>
                  </th>
                  <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Producto</h5></th>
                  <th style=" padding: 0 !important; margin: 0 !important;">
                    <h5 style="font-weight: bold;">Cantidad</h5>
                  </th>
                   
                  <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Usuario que autorizó</h5></th>
                  <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Usuario que creo la orden</h5></th>
                  <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Precio Compra</h5></th>
                  <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Precio venta</h5></th>
                  <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">Proveedor</h5></th>
                </tr>
              
                <tbody>
                <tr v-for="(item, idx) in detalleorden" v-bind:key="idx" style=" padding: 0 !important; margin: 0 !important;">
                  
                    <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{ item.compra.no_factura_c  }}
                    </h6>
                  </td> 
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{item.compra.fecha_compra_c  }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{ item.stock.producto.nombre_producto }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6 >
                      {{ item.cantidad_compra  }}
                    </h6>
                  </td>
                   
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{item.compra.orden_compra.usuario_autoriza.empleado.persona.nombre_persona+
                        " " +item.compra.orden_compra.usuario_autoriza.empleado.persona.apellido_persona  }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{item.compra.orden_compra.user.empleado.persona.nombre_persona+
                      " " +item.compra.orden_compra.user.empleado.persona.apellido_persona  }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6 align="right">
                      {{  money(item.stock.precio_compra_stock?item.stock.precio_compra_stock:0.00)  }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6 align="right">
                      {{  money(item.stock.precio_venta_stock?item.stock.precio_venta_stock:0.00)  }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6 align="right">
                      {{ item.stock.proveedore.company_proveedor +' | '+ item.stock.proveedore.persona.nombre_persona }}
                    </h6>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
  <Layout v-else>
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark"> 
          <div class="card-body">
            <br/>
            <div  class="row" align="center">
                <div class="col" align="left">
                    <form>
            <!-- Descripcion -->
            <div class="col-12">
              <div class="mb-3">
                <div class="row">
                <label for="phone">Seleccine el rango de fechas</label>
                </div>
                <div class="row">
                <label class="d-inline-flex align-items-center">
                    <date-picker style="max-width: 230px;" v-model="rangode_fecha" range append-to-body lang="en" confirm confirm-text="Aceptar"  @input="changeTypeDates()"></date-picker>
                </label>   
                </div>
                <div class="row">
                <label for="phone">Seleccine el producto a buscar</label>
                </div>
                <div class="row">
                <label class="d-inline-flex align-items-center">
                    <v-select
                    style="min-width: 230px;"
                    @search="onFiltered"
                    placeholder="Buscar..."
                    v-model="search" :options="arrayPro"
                    item-value="stockId"
                    :getOptionLabel="prod => prod.Stock.producto.nombre_producto+' | '+prod.Stock.codigo_stock"
                ></v-select>
                </label>   
                </div>         
              </div>
            </div>
            <!-- Botones -->
            <div class="text-end pt-5 mt-3">
              <b-button
                @click="generar"
                variant="success"
                class="ms-1"
                >Generar Reporte</b-button
              >
            </div>
          </form>    
            </div>
        </div>
        </div>
    </div>
    </div>
    </div>
  </Layout>
</template>
<style>
.grises {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}

@media print {
  @page {
    margin: 0;
    size: auto;
  }
}
</style>
